<template>
    <b-modal :active.sync="isModalActive" :width="600" scroll="keep" :can-cancel="canCancel" @close="closeModal">
        <div class="border border-blue-light rounded shadow bg-white p-4">
            <form @submit.prevent="saveCost" class="w-full">
                <header class="font-thin uppercase text-blue-light modal-card-head_ mb-4">
                    {{ $t(type === 0 ? 'edit_indirect_cost' : 'edit') }}
                </header>
                <div class="modal-card-body_ relative">
                    <div class="flex flex-wrap mx-4">
                        <div class="w-1/2 px-4">
                            <b-field :label="$t('code')">
                                <b-input v-model="cost.code" title="code" required name="code"
                                    :placeholder="$t('code')" maxlength="100" />
                            </b-field>
                        </div>
                        <div class="w-1/2 px-4">
                            <b-field :label="$t('name')">
                                <b-input v-model="cost.name" title="name" required name="name"
                                    :placeholder="$t('name')" maxlength="255" />
                            </b-field>
                        </div>
                    </div>
                    <div class="flex flex-wrap mx-4 mb-3 justify-end">
                        <v-button type="submit" class="px-4">{{ $t('save') }}</v-button>
                    </div>
                </div>
            </form>
        </div>
    </b-modal>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        projectId: {
            type: Number,
            required: true
        },
        type: {
            type: Number,
            required: true // 0 = indirecto, 1 = directo
        }
    },
    data() {
        return {
            isModalActive: false,
            canCancel: ['escape', 'x', 'outside'],
            cost: {
                code: '',
                name: ''
            },
            costId: null
        };
    },
    methods: {
        show(cost) {
            this.cost = { ...cost };
            this.costId = cost.id;
            this.isModalActive = true;
        },
        closeModal() {
            this.isModalActive = false;
        },
        async saveCost() {
            try {
                const {data} = await axios.put(`/api/v2/costs/${this.costId}`, {
                    code: this.cost.code,
                    name: this.cost.name,
                    project_id: this.projectId,
                    type: this.type
                });
                if (data.data && data.data.id) {
                    this.$toast.open({
                        message: this.$t('cost_updated_successfully'),
                        type: 'is-success',
                        position: 'is-top-right'
                    });
                    this.$emit('reload-list');
                    this.closeModal();
                } else {
                    this.$toast.open({
                        message: this.$t('error_updating_cost'),
                        type: 'is-danger',
                        position: 'is-top-right'
                    });
                }
            } catch (error) {
                this.$toast.open({
                    message: this.$t('error_updating_cost'),
                    type: 'is-danger',
                    position: 'is-top-right'
                });
                console.error('Error updating cost:', error);
            }
        }
    }
}
</script>

<style scoped></style>